"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const node_1 = require("../node");
const signature_1 = require("../signature");
const grain_1 = require("../util/grain");
class TableInputNode extends node_1.default {
    static from(obj) {
        if (obj['type'] === 'table')
            return new TableInputNode(obj['dataset'], obj['columns']);
        return null;
    }
    constructor(dataset, columns) {
        super('Table input node');
        this.dataset = dataset.toLowerCase();
        this.columns = columns.map(c => c.toLowerCase());
    }
    getSignature(datasetRepo) {
        let signature = new signature_1.default();
        signature.columns = this.columns.map(c => new signature_1.ColumnSignature(c, this.id));
        signature.grains = (0, grain_1.resolveGrain)(datasetRepo.datasetByName[this.dataset], datasetRepo);
        return signature;
    }
    checkPort() {
        return false; // Input nodes have no incoming ports
    }
    validate() {
        return true; // Input nodes are terminal, so nothing to check
    }
    serialize() {
        return super.serialize({
            type: 'table',
            dataset: this.dataset,
            columns: this.columns,
        });
    }
}
exports.default = TableInputNode;
